import { inject, Injectable } from '@angular/core';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { RealmModel } from '../models/realm.model';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { STORAGE_KEYS } from '../../shared/constants/storage-keys';

@Injectable({
  providedIn: 'root',
})
export class RealmService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(ConfigurationService).configuration;
  private readonly storageService = inject(LocalStorageService);

  readonly realm = this.storageService.signal<string | undefined>(STORAGE_KEYS.REALM, undefined);
  readonly mail = this.storageService.signal<string | undefined>(STORAGE_KEYS.MAIL, undefined);

  private readonly realmEndpoint = this.config.api.endpoints.realm;
  private readonly api = this.config.api.backendUrl;
  private readonly realmToken = this.config.api.realmToken;

  getRealmFromMail(mail: string): Observable<RealmModel> {
    const headers = new HttpHeaders().set('x-api-key', this.realmToken);

    return this.httpClient
      .get<RealmModel>(`${this.api}/${this.realmEndpoint}/user?mail=${mail}`, { headers })
      .pipe(
        map((realm: RealmModel) => {
          realm.mail = mail;
          return realm;
        }),
        tap((realm: RealmModel) => {
          this.realm.set(realm.realm);
          this.mail.set(realm.mail);
        }),
      );
  }

  async clearStorage() {
    this.storageService.remove(STORAGE_KEYS.REALM);
    this.storageService.remove(STORAGE_KEYS.MAIL);
  }
}
